import {Component, OnDestroy, OnInit} from '@angular/core';
import {RoutemapService} from '../../../core/services/routemap.service';
import {Subscription} from 'rxjs';
import {ContratMenuConviveDTO} from '../../../core/dtos/contratmenuconvive-dto';
import {ActivatedRoute} from '@angular/router';
import {UtilsService} from '../../../core/utils/utils.service';
import {CmcPlcSupplier} from './cmc-points-de-livraison-resolver.service';
import {PointDeLivraisonDTO} from '../../../core/dtos/point-de-livraison-d-t-o';
import {FS_ROUTES} from '../../../core/constants';
import {ContratMenuConvive__ModeleNutriDTO} from '../../../core/dtos/contratmenuconvive__modele-nutri-dto';

@Component({
    selector: 'yo-cmc-points-de-livraison',
    templateUrl: './cmc-points-de-livraison.component.html',
    styleUrls: ['./cmc-points-de-livraison.component.scss'],
    standalone: false
})
export class CmcPointsDeLivraisonComponent implements OnInit, OnDestroy {

  periodes: ContratMenuConvive__ModeleNutriDTO[] = [];
  selectedPeriode: ContratMenuConvive__ModeleNutriDTO;

  contratMenuConvive: ContratMenuConviveDTO;
  pointsDeLivraison: PointDeLivraisonDTO[];
  selectedPointDeLivraison: PointDeLivraisonDTO;
  subscriptionRoute: Subscription;

  constructor(private route: ActivatedRoute,
              private routeMapSvc: RoutemapService,
              public utils: UtilsService) {
  }

  ngOnInit() {
    this.subscriptionRoute = this.route.data
      .subscribe((data: { cmcPlcSupplier: CmcPlcSupplier }) => {

        this.pointsDeLivraison = data.cmcPlcSupplier.pointsDeLivraison;
        this.contratMenuConvive = data.cmcPlcSupplier.contratMenuConvive;
        this.periodes = data.cmcPlcSupplier.periodes;

        this.selectedPeriode = this.utils.isCollectionNullOrEmpty(this.periodes) ? undefined : this.periodes[0];
        this.selectedPointDeLivraison = this.utils.isCollectionNullOrEmpty(this.pointsDeLivraison) ? undefined : this.pointsDeLivraison[0];
        this.loadTauxDePrisePrev(this.selectedPeriode, this.selectedPointDeLivraison);
      });
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subscriptionRoute);
  }

  onPlcChange = (plc: PointDeLivraisonDTO) => {
    this.selectedPointDeLivraison = plc;
    this.loadTauxDePrisePrev(this.selectedPeriode, this.selectedPointDeLivraison);
  };

  onPlcListChange = (plcList: PointDeLivraisonDTO[]) => {
    this.pointsDeLivraison = plcList;
    if (!this.pointsDeLivraison?.length) {
      this.routeMapSvc.goToSecondaryRoute([FS_ROUTES.GCO_CMC, this.contratMenuConvive.contratMenuId, this.contratMenuConvive.id, 'points-de-livraison']);
    }
  };

  onPeriodeChange = (periode: ContratMenuConvive__ModeleNutriDTO) => {
    this.selectedPeriode = periode;
    this.loadTauxDePrisePrev(this.selectedPeriode, this.selectedPointDeLivraison);
  };

  loadTauxDePrisePrev = (periode: ContratMenuConvive__ModeleNutriDTO, pointDeLivraison: PointDeLivraisonDTO) => {
    if (!this.utils.isNullOrEmpty(periode) && !this.utils.isNullOrEmpty(pointDeLivraison)) {
      this.routeMapSvc.goToSecondaryRoute([FS_ROUTES.GCO_CMC, this.contratMenuConvive.contratMenuId, this.contratMenuConvive.id, 'points-de-livraison', periode.id, pointDeLivraison.id]);
    }
  };
}
